import request from "./request";
import apis from "./apis";

const {
  busTimeInfo,
  schoolInfo,
  studentInfo,
  studentStatus,
  studentTakeBus,
} = apis.bus;

const bus = {
  getBusTimeInfo: () => {
    return request.get(busTimeInfo);
  },
  createBusTimeInfo: (data: Object) => {
    return request.post(busTimeInfo, data);
  },
  updateBusTimeInfo: (data: Object) => {
    return request.put(busTimeInfo, data);
  },
  deleteBusTimeInfo: (data: Object) => {
    return request.delete(busTimeInfo, data);
  },
  getSchoolInfo: (data: Object) => {
    return request.get(schoolInfo, data);
  },
  createSchoolInfo: (data: Object) => {
    return request.post(schoolInfo, data);
  },
  updateSchoolInfo: (data: Object) => {
    return request.put(schoolInfo, data);
  },
  deleteSchoolInfo: (data: Object) => {
    return request.delete(schoolInfo, data);
  },
  getStudentInfo: (data: Object) => {
    return request.get(studentInfo, data);
  },
  updateStudentStatus: (data: Object) => {
    return request.post(studentStatus, data);
  },
  updateStudentTakeBus: (data: Object) => {
    return request.put(studentTakeBus, data);
  },
};

export default bus;